// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__19Cdv","button":"styles_button__Bxz4Y","is-loading":"styles_is-loading__3oqni"};